<template>
  <div class="mnp-in-summary">
    <div class="summary-head-box">
      <slot name="txtBefore"></slot>
      <slot name="txtBeforeData"></slot>
      <b-row class="providerKey">
        <b-col md="" sm="" class="label">
          <slot name="lblProviderKey">Name des Anbieters:</slot>
        </b-col>
        <b-col md="" sm="" class="value">
          {{selectedKeys.providerKey}}
        </b-col>
      </b-row>
      <b-row class="portationMsisdn">
        <b-col md="" sm="" class="label">
          <slot name="lblPortationMsisdn">Zu portierende Rufnummer:</slot>
        </b-col>
        <b-col md="" sm="" class="value">
          {{portationMsisdn}}
        </b-col>
      </b-row>
      <b-row class="fullName">
        <b-col md="" sm="" class="label">
          <slot name="lblFullName">Name im alten Vertrag:</slot>
        </b-col>
        <b-col md="" sm="" class="value">
          {{salutation(person.gender)}} {{person.firstName}} {{person.lastName}}
        </b-col>
      </b-row>
      <b-row class="birthDate">
        <b-col md="" sm="" class="label">
          <slot name="lblBirthDate">Geburtstag im alten Vertrag:</slot>
        </b-col>
        <b-col md="" sm="" class="value">
          {{person.birthDate}}
        </b-col>
      </b-row>
      <slot name="txtAfterData"></slot>
      <div class="payment-information">
        <slot name="txtBeforePaymentInformation"></slot>
        <ChangePaymentViewWrapper :show-stepper="false">
          <template v-for="slot in possibleChildSlotsFor('ViewWrapper')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ChangePaymentViewWrapper>
        <slot name="txtAfterPaymentInformation"></slot>
      </div>
      <br>
<!--      <p>Die Vertragszusammenfassung finden Sie <span class="link" @click="download()">hier</span>.</p>-->
      <slot name="txtAfter"></slot>
    </div>
    <Stepper
      @prev="back()"
      :showPrev="false"
      @next="confirm()"
      :loading-next="loading"
      :disabled-next="loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import ChangePaymentViewWrapper from '@/components/process/generic/Payment/ChangePayment/ViewWrapper.vue'
import { mapActions, mapGetters } from 'vuex'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'
import Stepper from '@/components/generic/Stepper.vue'
import processSteps from '@/mixins/processSteps'
import { stepName as previousProcessStep } from './Data.vue'
import { stepName as nextProcessStep } from './Success.vue'
// import axios from 'axios'
// import FileSaver from 'file-saver'

export const stepName = 'mnpInSummary'

export default {
  name: 'MnpInSummary',
  data () {
    return {
      loading: false
    }
  },
  props: {},
  components: {
    ChangePaymentViewWrapper,
    Stepper
  },
  computed: {
    isNoPayment () {
      return this.paymentInformation.paymentType === null
    },
    isCreditCard () {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'creditCard'
      }
      return false
    },
    isBankAccount () {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'bankAccount'
      }
      return false
    },
    ...mapGetters('mnpIn', [
      'person', 'selectedKeys', 'portationMsisdn', 'contractUrl'
    ]),
    ...mapGetters([
      'accessToken'
    ])
  },
  methods: {
    ...mapActions('mnpIn', [
      'confirmMnpIn'
    ]),
    salutation (gender) {
      switch (gender) {
        case 'MALE': return 'Herr'
        case 'FEMALE': return 'Frau'
      }
    },
    back () {
      this.goToStep(this.previousStep)
    },
    confirm () {
      this.loading = true
      this.confirmMnpIn({
        nextStep: this.nextStep
      })
        .then(() => {
          this.loading = false
        }, () => {
          this.loading = false
        })
    }
    /* download () {
      const me = this

      axios.get(me.contractUrl, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, 'Vertragszusammenfassung.pdf')
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    } */
  },
  mixins: [
    slotProxy(),
    processSteps(stepName, previousProcessStep, nextProcessStep)
  ],
  apollo: {
    paymentInformation: function () {
      return wrapQuery(
        gql`query changePayment {
          paymentInformation {
            paymentType {
            ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
           }
          }
        }`, this, 'paymentInformation'
      )
    }
  }
}
</script>
